import React from 'react';
import { Store } from 'lucide-react';

function greeting(date = new Date()) {
    const h = date.getHours();
    if (h < 5)  return 'לילה טוב';
    if (h < 12) return 'בוקר טוב';
    if (h < 17) return 'צהריים טובים';
    if (h < 21) return 'ערב טוב';
    return 'לילה טוב';
}

/**
 * Dashboard hero. Calm by design: just a time-of-day greeting, the store
 * name, and the store image. Status surfaces and quick actions live in
 * the nav and the cards below.
 */
export function DashboardHero({ store }) {
    const name = store?.name || 'החנות שלי';

    return (
        <div className="relative overflow-hidden rounded-2xl shadow-card animate-slide-up">
            <div className="absolute inset-0 bg-gradient-to-l from-brand-700 via-brand-600 to-brand-500" aria-hidden="true" />
            <div className="absolute -top-16 -left-16 w-56 h-56 rounded-pill bg-white/10 blur-2xl" aria-hidden="true" />
            <div className="absolute -bottom-20 right-1/4 w-48 h-48 rounded-pill bg-white/5 blur-2xl" aria-hidden="true" />

            <div className="relative p-6 lg:p-8 text-ink-inverse">
                <div className="flex items-center gap-5">
                    <div className="w-20 h-20 lg:w-24 lg:h-24 rounded-2xl overflow-hidden ring-2 ring-white/40 shrink-0 bg-white/15 backdrop-blur-sm">
                        {store?.profile_image ? (
                            <img src={store.profile_image} alt={name} className="w-full h-full object-cover" />
                        ) : (
                            <Store className="w-full h-full p-4 text-white/90" />
                        )}
                    </div>

                    <div className="flex-1 min-w-0">
                        <div className="text-xs lg:text-sm font-semibold tracking-[0.12em] uppercase text-white/75">
                            {greeting()}
                        </div>
                        <h1 className="text-3xl lg:text-4xl font-bold tracking-tight mt-1 truncate text-white">
                            {name}
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardHero;
